import { createFormContext } from '@mantine/form';
import { iSearch } from '../Search/models';

export const [FormProvider, useFormContext, useForm] = createFormContext<iSearch>();
